import _extends from "@babel/runtime/helpers/extends";
import { requestIndexedDBValues } from '@gcc/autobahn-utilities';
import { logEventType } from '../trackerTypes';
import { pcpAddToCartToThdCanadaAnalytics, pcpToThdCanadaAnalytics } from './pcp-to-thd-canada-analytics';
import { pipToThdCanadaAnalytics } from './pip-to-thd-canada-analytics';
import sendToThdCanada from './send-to-thd-canada';
import ThdCanadaPayload, { ThdCanadaLogData } from './thd-canada-payload';

function sendPageLoadEvent(data, navigationData) {
  const eventName = 'Page Load';
  const payload = ThdCanadaPayload(data, navigationData);
  sendToThdCanada(eventName, payload);
}

function redirect(redirectUrl) {
  setTimeout(() => {
    window.location = redirectUrl;
  }, 500);
}

const pcpPageloadDataKey = 'pcpPageLoad';

function setPcpPageLoadData(payload) {
  window.sessionStorage.setItem(pcpPageloadDataKey, JSON.stringify(payload));
}

function getPcpPageLoadData() {
  const data = window.sessionStorage.getItem(pcpPageloadDataKey);

  if (!data) {
    return {};
  }

  return JSON.parse(data);
}

function removePcpPageLoadData() {
  window.sessionStorage.removeItem(pcpPageloadDataKey);
}

export const thdCanadaTracker = {
  pcpPageLoad: (storeState, cultureCode) => {
    const data = pcpToThdCanadaAnalytics(storeState, cultureCode);
    const dbName = 'AutoBahnPcpPageDb';
    const storeName = 'EVTPcpPageLoadPayload';
    const key = 'autobahn-pcp-page-load-data';
    requestIndexedDBValues(dbName, storeName, key, valueRequest => {
      const pcpNavData = (valueRequest == null ? void 0 : valueRequest.result) || getPcpPageLoadData();
      removePcpPageLoadData();
      sendPageLoadEvent(data, pcpNavData);
    });
  },
  pcpAddToCart: addToCartData => {
    const dbName = 'SavedAutobahnEVT';

    window.indexedDB.deleteDatabase(dbName).onsuccess = () => {
      const storeName = 'payload';
      const key = 'logName';
      const request = window.indexedDB.open(dbName);

      request.onupgradeneeded = event => {
        const db = event.target.result;
        db.createObjectStore(storeName, {
          keyPath: key
        });
      };

      request.onsuccess = () => {
        const analytics = _extends({
          [key]: 'autobahn-pcp-add-to-cart-data'
        }, pcpAddToCartToThdCanadaAnalytics(addToCartData));

        const tx = request.result.transaction(storeName, 'readwrite');
        const objStore = tx.objectStore(storeName);
        objStore.put(analytics); // eslint-disable-next-line

        console.log('Canada Analytics: Update Indexeddb', analytics);
        request.result.close();
        redirect(addToCartData.redirectUrl);
      };
    };
  },
  pipPageLoad: (thdPipViewModel, cultureCode) => {
    const data = pipToThdCanadaAnalytics(thdPipViewModel, cultureCode);
    const dbName = 'AutoBahnProductPageDb';
    const storeName = 'EVTProductPageLoadPayload';
    const key = 'autobahn-pip-page-load-data';
    requestIndexedDBValues(dbName, storeName, key, valueRequest => {
      sendPageLoadEvent(data, valueRequest == null ? void 0 : valueRequest.result);
    });
  },

  /**
   * @function pipCustomizeClick
   * @inner
   */
  pipCustomizeClick: () => {
    setPcpPageLoadData({
      navigationBlock: {
        type: 'edit customization',
        value: 'customize and buy',
        subType: 'product card',
        location: 'product page'
      },
      search: {
        redirect: true,
        keyword: ''
      }
    });
  },

  /**
   * @function log
   * @param {import('../trackerTypes.js').LogInfo} logInfo
   * @param {string} eventType
   * @inner
   */
  log: (logInfo, eventType = logEventType.information) => {
    const data = ThdCanadaLogData(logInfo, eventType);
    sendToThdCanada(data.event.type, data.payload);
  },

  /**
   * @function error
   * @param {import('../trackerTypes.js').LogInfo} logInfo
   * @inner
   */
  error: logInfo => thdCanadaTracker.log(logInfo, logEventType.error),

  /**
   * @function warning
   * @param {import('../trackerTypes.js').LogInfo} logInfo
   * @inner
   */
  warning: logInfo => thdCanadaTracker.log(logInfo, logEventType.warning)
};
export default thdCanadaTracker;